// components/Navbar/Navbar.jsx
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import "./Navbar.css";
import img from "../../assests/job.png";

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { currentUser, logout } = useAuth();
  const navigate = useNavigate();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const handleLogout = async () => {
    try {
      await logout();
      navigate("/");
      closeMenu();
    } catch (error) {
      console.error("Failed to logout:", error);
    }
  };

  return (
    <nav className="navbar">
      <div className="nav-container">
        <Link to="/" className="nav-logo" onClick={closeMenu}>
          {/* <span className="logo-o">o</span>
          <span className="logo-rest">rgigs</span> */}
          <img
            src={img}
            alt="jobhub manpower solution Logo"
            className="nav-logo-image"
          />
        </Link>

        <ul className={`nav-menu ${isMenuOpen ? "active" : ""}`}>
          <li>
            <Link to="/" className="nav-link" onClick={closeMenu}>
              Home
            </Link>
          </li>
          {/* <li>
            <Link to="/events" className="nav-link" onClick={closeMenu}>
              Events
            </Link>
          </li> */}
          <li>
            <Link to="/features" className="nav-link" onClick={closeMenu}>
              Features
            </Link>
          </li>
          <li>
            <Link to="/about" className="nav-link" onClick={closeMenu}>
              About Us
            </Link>
          </li>
          <li>
            <Link to="/contact" className="nav-link" onClick={closeMenu}>
              Contact
            </Link>
          </li>

          {currentUser ? (
            <>
              {/* <li>
                <Link to="/my-events" className="nav-link" onClick={closeMenu}>
                  My Events
                </Link>
              </li> */}
              <li className="nav-user-info">
                <span className="nav-link user-name">
                  Hi,{" "}
                  {currentUser.firstName ||
                    currentUser.displayName?.split(" ")[0] ||
                    "User"}
                  !
                </span>
              </li>
              <li>
                <button className="nav-link logout-btn" onClick={handleLogout}>
                  Logout
                </button>
              </li>
            </>
          ) : (
            <li>
              {/* <Link
                to="/login"
                className="nav-link login-signup-btn"
                onClick={closeMenu}
              >
                Login / Sign Up
              </Link> */}
            </li>
          )}
        </ul>

        <button
          className={`nav-toggle ${isMenuOpen ? "active" : ""}`}
          onClick={toggleMenu}
        >
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </button>
      </div>
<a
  href="mailto:contact@jobhubmanpowersolution.com?subject=Inquiry%20from%20Website&body=Hi%20i%am%interested%in%procuring%your%services,"
  className="whatsapp-float"   // keeping same classname for styling
  target="_blank"
  rel="noopener noreferrer"
  aria-label="Send us an Email"
  title="Send us an Email"
>
  <img
    src="https://upload.wikimedia.org/wikipedia/commons/4/4e/Mail_%28iOS%29.svg"
    alt="Email"
    width="32"
    height="32"
  />
</a>

    </nav>
  );
};

export default Navbar;
